import { render, staticRenderFns } from "./MergeTickets.vue?vue&type=template&id=0dd18d99"
import script from "./MergeTickets.vue?vue&type=script&lang=js"
export * from "./MergeTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports